import { useEffect, useState, useRef } from 'react';
import { readPrintConfig, DEFAULT_PRINT_CONFIG } from '../../hooks/usePrintConfig';

export const PrintPage = () => {
  const [content, setContent] = useState<string>('');

  // Permite que la prueba de impresión use la config del draft (no guardada aún)
  const printConfig = (() => {
    try {
      const override = sessionStorage.getItem('printConfigOverride');
      if (override) {
        sessionStorage.removeItem('printConfigOverride');
        return { ...DEFAULT_PRINT_CONFIG, ...JSON.parse(override) };
      }
    } catch { /* ignorar */ }
    return readPrintConfig();
  })();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Obtener el contenido HTML del sessionStorage
    const printContent = sessionStorage.getItem('printContent');
    
    if (printContent) {
      setContent(printContent);
      // Limpiar después de obtener
      sessionStorage.removeItem('printContent');
    }
  }, []);

  useEffect(() => {
    if (!content || !contentRef.current) return;

    // Esperar a que todas las imágenes se carguen
    const images = contentRef.current.getElementsByTagName('img');
    
    if (images.length === 0) {
      // No hay imágenes, imprimir directamente
      setTimeout(() => {
        window.focus();
        window.print();
      }, 100);
      return;
    }

    // Hay imágenes, esperar a que se carguen
    const imagePromises = Array.from(images).map(
      (img) =>
        new Promise<void>((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = () => resolve();
            img.onerror = () => resolve(); // Continuar aunque falle
          }
        })
    );

    Promise.all(imagePromises).then(() => {
      // Todas las imágenes cargadas, imprimir
      setTimeout(() => {
        window.focus();
        window.print();
      }, 200);
    });
  }, [content]);

  if (!content) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: printConfig.fontFamily,
      }}>
        Preparando impresión...
      </div>
    );
  }

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: ${printConfig.fontFamily};
          width: ${printConfig.paperWidth};
          max-width: ${printConfig.paperWidth};
          padding: 4px;
          margin: 0;
          line-height: 1.4;
        }
        table { table-layout: fixed; width: 100%; }
        @media print {
          @page { margin: 0; size: ${printConfig.paperWidth} auto; }
          body { padding: 2px; }
        }
      `}</style>
      <div ref={contentRef} dangerouslySetInnerHTML={{ __html: content }} />
    </>
  );
};
